import fileDownload from 'js-file-download';
import api from '../api/Api';
import { ExportGraph, GraphData, TotalizerDashboardFilter, TotalizerResponse } from './DashboardService';

/* mesmos contratos do DashboardService da NFe, apontando para /cte/dashboard */

export const findTotalByFilter = async (filter: TotalizerDashboardFilter): Promise<TotalizerResponse> => {
  return api.get<TotalizerResponse>('/cte/dashboard/total', { params: filter }).then(({ data }) => data);
}

export const exportGraph = async (requestData: ExportGraph) => {
  const res = await api.post('/cte/dashboard/graph/export', requestData, { responseType: 'blob' });
  fileDownload(res.data, res.headers.filename)
}

export const getCountGraphData = async (filter: TotalizerDashboardFilter): Promise<GraphData[]> => {
  return api.get<GraphData[]>('/cte/dashboard/count-grouped-by-period', { params: filter }).then(({ data }) => data);
}

export const getTotalAmountGraphData = async (filter: TotalizerDashboardFilter): Promise<GraphData[]> => {
  return api.get<GraphData[]>('/cte/dashboard/total-amount-grouped-by-period', { params: filter }).then(({ data }) => data);
}
